<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">Would you like to associate <strong> {{ data.contact.name }} </strong>with <strong> {{ data.company }} </strong>?</p>
    <button type="button" @click="create" class="btn btn-fill btn-info">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        addContact: false
      }
    },
    methods: {
      create() {
        this.$eventHub.$emit('show-modal-4', 'Company Contact', this.data.contact, '800px')
        this.addContact = true
        this.closeModal()
      },
      closeModal() {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.addContact) {
        this.$eventHub.$emit('noCompanyContactSelected', this.data.type)
      }
    }
  }
</script>
